type fetchSpaceDoodlesByAddressesInput = {
  addresses: string[];
};

export const fetchSpaceDoodlesByAddresses = async ({
  addresses = [],
}: fetchSpaceDoodlesByAddressesInput) => {
  const response = await fetch(process.env.NEXT_PUBLIC_GQL_API_URL ?? '', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      query: `query GetSpaceDoodlesByAddress($data: GetSpaceDoodlesByAddressInput!) {
            getSpaceDoodlesByAddress(data: $data) {
                totalPoints
                totalSpaceDoodles
                items {
                    address
                    points
                  }
            }
        }`,
      variables: {
        data: {
          addresses,
        },
      },
    }),
  });

  const spaceDoodlesByAddresses = await response.json();
  return {
    spaceDoodlesByAddresses:
      spaceDoodlesByAddresses?.data?.getSpaceDoodlesByAddress,
  };
};
